import Vue from 'vue'
import App from './App.vue'
import './publicPath'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight'
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog'
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage'
import { faNewspaper } from '@fortawesome/free-solid-svg-icons/faNewspaper'
import { faListOl } from '@fortawesome/free-solid-svg-icons/faListOl'
import { faVials } from '@fortawesome/free-solid-svg-icons/faVials'
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueContentLoading from 'vue-content-loading';
import VueLazyload from 'vue-lazyload'
import webmessage from '../../globalComponents/webmessage.vue'
Vue.component('webmessage', webmessage);
Vue.config.ignoredElements = ['wsm']
Vue.use(VueLazyload, {
  // set observer to true
  observer: true,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1,
  }
})
library.add(faAngleRight, faCog, faImage, faNewspaper, faListOl, faVials, faSave, faSpinner, faStar)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-content-loading', VueContentLoading)

Vue.config.productionTip = false

document.querySelectorAll(".relationListWidget").forEach(element => {
  var currentSettings = element.dataset.settings;
  if (typeof currentSettings == 'undefined' || currentSettings == '') {
    currentSettings = '{"resultNo": 5, "mode": "articles", "activeTags": [], "showImage": true, "categoriesAllowed": [], "attrs": {"attr": [],"values": []}}'
  }
  new Vue({
    render: h => h(App),
    name: "relationWidget",
    data: {
      id: element.dataset.contentid,
      admin: element.dataset.admin,
      isadmin: element.dataset.admin,
      webhost: element.dataset.webhost,
      pageid: element.dataset.pageid,
      newsid: element.dataset.newsid,
      productid: element.dataset.productid,
      attrids: element.dataset.attr.replace(/\|/g, ''),
      language: JSON.parse(element.dataset.language),
      settings: JSON.parse(currentSettings),
      ingredientssectionid: element.dataset.ingredientssectionid,
      ingredientname: element.dataset.ingredientname,
      isIngredients: element.dataset.isingredients == 'Y' ? true : false
    },
  }).$mount(element)
})